.list {
  display: grid;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
  background: var(--panel);
}

.icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: var(--radius-ctl);
  background: var(--accent-w);
  color: var(--accent);
}

.body {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.title {
  display: inline-flex;
  align-items: center;
  min-height: var(--target-min);
  font-size: var(--t-dense);
  font-weight: 650;
  color: var(--ink);
  text-decoration: none;
}

a.title:hover {
  color: var(--accent);
  text-decoration: underline;
}

.status {
  display: inline-flex;
  font-size: var(--t-min);
}

.muted {
  color: var(--muted);
}

